import type { IValidationResult, IValidatorParams } from "@edaz/services/baseValidationService";
import castArray from "lodash/castArray";

export interface IsFileTypeOptions {
  type?: string | string[];
}

export default function isFileType(
  value: File | undefined,
  options: IsFileTypeOptions,
  params?: IValidatorParams
): IValidationResult {
  if (value) {
    if (!(value instanceof File)) {
      return {
        isValid: false,
        errors: {
          constraints: {
            isNotFile: "true",
          },
        },
      };
    }

    if (options.type) {
      const types = castArray(options.type);

      if (!types.includes(value.type)) {
        return {
          isValid: false,
          errors: {
            constraints: {
              notDesiredFileType: "false",
            },
            params: [types.join(",")],
          },
        };
      }
    }
  }

  return {
    isValid: true,
  };
}
